import React from "react";
import {Button, PageHeader} from "antd";

const DefaultPageHeader = ({title, subtitle = '',
                               buttons = [],
                               onButtonClick}) => {

    const handleButtonClick = (event, key) => {
        onButtonClick && onButtonClick(event, key)
    }

    return (
        <PageHeader
            style={{padding: 0}}
            ghost={true}
            title={title}
            subTitle={subtitle}
            extra={buttons.map(item => <Button key={item.key} onClick={event => handleButtonClick(event, item.key)}>{item.name}</Button>)}>
        </PageHeader>
    )
}

export default DefaultPageHeader